const BarcodeConfigurationFormValues = {
  formName: "BarcodeConfigurationForm",
  formMethod: "POST",
  cancelAction: "MasterListsPage",
  submitOnCancel: false,
  cancelMethod: "POST",
  numMaxOrderLabels: 0,
  numMaxSpecimenLabels: 0,
  numMaxAliquotLabels: 0,
  numDefaultOrderLabels: 0,
  numDefaultSpecimenLabels: 0,
  numDefaultAliquotLabels: 0,
  heightOrderLabels: 0,
  widthOrderLabels: 0,
  heightSpecimenLabels: 0,
  widthSpecimenLabels: 0,
  heightBlockLabels: 0,
  widthBlockLabels: 0,
  heightSlideLabels: 0,
  widthSlideLabels: 0,
  collectionDateCheck: true,
  collectedByCheck: true,
  testsCheck: true,
  patientSexCheck: true,
  prePrintDontUseAltAccession: true,
  prePrintAltAccessionPrefix: "",
};

export default BarcodeConfigurationFormValues;
